import React from 'react';
import { theme } from '../../constants/theme';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';
import signupbgbackup from '../../asset/images/icons/signupbgbackup.svg';
import signupAnimation from '../../asset/images/icons/signup_animation_1.svg';

const AnimationBackground: React.FC = () => {
    const { themeStyle } = useThemeContext();
    const muiTheme = useTheme();
    const over1200 = useMediaQuery(muiTheme.breakpoints.up(1200));

    return (
        <>
            {over1200 && (
                <Box
                    sx={{
                        bgcolor: theme[themeStyle].signUpBackground,
                        minWidth: '40%',
                        minHeight: '100vh',
                        borderTopLeftRadius: 12,
                        borderBottomLeftRadius: 12,
                    }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            position: 'absolute',
                            top: '10%',
                            right: '3%',
                            width: '35%',
                        }}>
                        <Typography
                            sx={{
                                fontSize: '20px',
                                display: 'flex',
                                color: theme[themeStyle].true_white,
                                fontFamily: FONT_ENUM.MAIN_REGULAR,
                            }}>
                            Welcome to{' '}
                            <strong style={{ fontFamily: FONT_ENUM.MAIN_BOLD, marginLeft: 5 }}>Thspian</strong>
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '24px',
                                width: '500px',
                                whiteSpace: 'pre-wrap',
                                color: theme[themeStyle].true_white,
                                fontFamily: FONT_ENUM.MAIN_BOLD,
                            }}>
                            Explore Top Thspian Content!
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                color: theme[themeStyle].true_white,
                                whiteSpace: 'pre-wrap',
                                maxWidth: '400px',
                                fontFamily: FONT_ENUM.MAIN_REGULAR,
                            }}>
                            Upload your work, connect with brands, campaigns, and start your creative journey.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            width: '100%',
                            height: '100vh',
                            backgroundImage: `url(${signupbgbackup})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover', // fills and crops if needed
                            backgroundPosition: 'center',
                        }}
                    />

                    <CustomLazyLoadImage
                        src={signupAnimation}
                        style={{
                            width: 'auto',
                            maxHeight: '70%',
                            position: 'absolute',
                            right: 0,
                            bottom: 0,
                        }}
                    />
                </Box>
            )}
        </>
    );
};

export { AnimationBackground };
